import { Brand, Effect, Array, pipe } from 'effect';
import * as Api from '../api';
// internal constructor - do not export
const TenantId = Brand.refined(x => typeof x === 'string', _ => Brand.error('nope'));
const Tenant = Brand.nominal();
export const fromApi = (apiTenant) => Tenant({
    id: TenantId(apiTenant.id),
    displayName: apiTenant.displayName,
});
export const getTenants = pipe(Api.Tenant.getTenants, Effect.map(Array.map(fromApi)), Effect.withRequestCaching(true));
